import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";

const ModalExportVoucher = ({
  isOpen,
  toggle,
  formData,
  handleChange,
  handleSubmit,
  loading,
  campanhas,
  parceiros,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>
          <span className="fw-semibold">Exportar Vouchers</span>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <FormGroup>
                <Label for="campanha_id" className="fw-medium">
                  Campanha
                </Label>
                <Input
                  id="campanha_id"
                  name="campanha_id"
                  type="select"
                  value={formData.campanha_id}
                  onChange={handleChange}
                >
                  <option value="">Selecione uma campanha</option>
                  {campanhas.map((campanha) => (
                    <option key={campanha.id} value={campanha.id}>
                      {campanha.nome}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </div>

            <div className="col-md-12">
              <FormGroup>
                <Label for="parceiro_id" className="fw-medium">
                  Parceiro
                </Label>
                <Input
                  id="parceiro_id"
                  name="parceiro_id"
                  type="select"
                  value={formData.parceiro_id}
                  onChange={handleChange}
                >
                  <option value="">Selecione um parceiro</option>
                  {parceiros.map((parceiro) => (
                    <option key={parceiro.id} value={parceiro.id}>
                      {parceiro.nome}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={toggle} disabled={loading}>
            Cancelar
          </Button>
          <Button type="submit" color="info" className="ms-2" disabled={loading}>
            {loading && <Spinner size="sm" className="me-2" />}
            Exportar CSV
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ModalExportVoucher; 